import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/components/page/HomePage.vue";
import PeriodicPage from "@/components/page/PeriodicPage.vue";
import ToolsPage from "@/components/page/ToolsPage.vue";

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: "/", component: HomePage },
    { path: "/periodic", component: PeriodicPage },
    { path: "/tools", component: ToolsPage },
    { path: "/sso/callback", redirect: "/" },
  ]
})